module.exports = __webpack_public_path__ + "static/media/logo-tufilandia.a53c6842.png";